__webpack_require__.p = "https://gift-pmxpu-cdn.didipay.com/static/manhattan_global_static/baldr-outside-app/";